export default __webpack_public_path__ + "static/media/logo.d424ece7.png";